module.exports = __webpack_public_path__ + "img/Pattern-04.5deea25d.jpg";